import { Loader } from '@ophelos/ui/components/loader';
import { useAuth } from '@ophelos/ui/contexts/workos-auth-context';
import { useState } from 'react';

/** Shared sign-out logic with loading overlay */
export function useSignOut() {
  const { signOut } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      // Run signOut and minimum display time in parallel
      await Promise.all([signOut(), new Promise((resolve) => setTimeout(resolve, 300))]);
    } catch (error) {
      console.error('Sign out error:', error);
    } finally {
      // Hard navigation ensures clean state transition —
      // React Router's navigate() can flash the app briefly before redirect
      window.location.href = '/login';
    }
  };

  return { isSigningOut, handleSignOut };
}

/** Full-screen overlay shown during sign-out */
export function SignOutOverlay({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center bg-background/50 backdrop-blur-sm">
      <Loader text="Signing out..." size="lg" />
    </div>
  );
}
